import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Button, LinearProgress } from '@material-ui/core';

import { selectUser } from 'entities/user/selectors';
import { selectBudgets } from 'entities/budget/selectors';
import { selectBudgetAllocations } from 'entities/budgetAllocation/selectors';
import { selectDonationMatchingRules } from 'entities/donationMatchingRule/selectors';
import { selectDonationCreditRules } from 'entities/donationCreditRule/selectors';
import { useInjectReducer } from 'utils/injectReducer';
import { useInjectEpics } from 'utils/injectEpics';

import { Privileges } from '../../utils/privileges';

import reducer from './reducers';
import epics from './epics';
import * as Actions from './actions';
import { selectLoading } from './selectors';
import DonationGivingRulesList from './DonationGivingRulesList';

const key = 'donationGivingRulesListPage';

const DonationRulesListPage = (): JSX.Element => {
  useInjectReducer({ key, reducer });
  useInjectEpics({ key, epics });

  const history = useHistory();
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const budgets = useSelector(selectBudgets);
  const donationMatchingRules = useSelector(selectDonationMatchingRules);
  const donationCreditRules = useSelector(selectDonationCreditRules);
  const corporateDonationsAllocations = useSelector(selectBudgetAllocations);
  const user = useSelector(selectUser);

  useEffect(() => {
    dispatch(Actions.initAction());
  }, []);

  if (user && !user.hasPrivilege(Privileges.ORGANIZATION_MANAGE_ORGANIZERS)) {
    history.replace('/');
  }

  return (
    <>
      <Helmet title="Giving Budgets &amp; Rules" />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h1>Giving Budgets &amp; Rules</h1>
        <Link to="/donations/budgets/new">
          <Button color="primary" size="large" variant="outlined" style={{ marginBottom: 10 }}>
            Create New Budget
          </Button>
        </Link>
      </div>
      {loading ? (
        <LinearProgress />
      ) : (
        <DonationGivingRulesList
          budgets={budgets}
          rulesList={donationMatchingRules
            .merge(donationCreditRules)
            .merge(corporateDonationsAllocations)}
        />
      )}
    </>
  );
};

export default DonationRulesListPage;
